import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { VerifyForgetPasswordOtpPayload } from "../type";

function useVerifyPasswordOtp() {
  return useMutation({
    mutationFn: (command: VerifyForgetPasswordOtpPayload) => {
      return authService.verifyForgetPasswordOtp(command);
    },
  });
}

export default useVerifyPasswordOtp;
